/* eslint-disable no-nested-ternary */
import React from 'react';
import './ui/utils/MuiClassNameSetup';

import { AppContext } from './capabilities/contextStore/AppContext';
import { useAppContext } from './capabilities/contextStore/useAppContext';
import { NotificationContext } from './capabilities/contextStore/NotificationContext';
import { useNotificationContext } from './capabilities/contextStore/useNotificationContext';
import AppContainer from './ui/container/AppContainer';
import { UnifiedRouter } from './unified-router/UnifiedRouter';
import { CCGThemeProvider } from './style/CCGThemeProvider/CCGThemeProvider';
import EnvironmentContextProvider from './capabilities/contextStore/EnvironmentContext/EnvironmentContextProvider';
import { DrawerContext } from './capabilities/contextStore/DrawerContext/DrawerContext';
import { useDrawerContext } from './capabilities/contextStore/DrawerContext/useDrawerContext';
import ServiceContextProvider from './capabilities/contextStore/ServiceContext/ServiceContextProvider';
import LanguageSelector from './capabilities/components/LanguageSelector/LanguageSelector';
import ContainerAppEnvChekoutSession from './components/ContainerAppEnvChekoutSession/ContainerAppEnvChekoutSession';
import useParseCheckoutSessionId from './shared/CheckoutSessionInitializer/useParseCheckoutSessionId';
import getAppEnvOrDefaultForHosted from './utils/getAppEnvOrDefaultForHosted';

const App = () => {
  const appContext = useAppContext();
  const notificationContext = useNotificationContext();
  const drawerContextValue = useDrawerContext();

  const onCancel = () => {
    window.self.close();
  };
  const standalonePage =
    window.location.pathname === '/payment-terms-and-conditions';

  const checkoutSessionId = useParseCheckoutSessionId();
  const appEnv = getAppEnvOrDefaultForHosted();

  return (
    <ServiceContextProvider>
      <CCGThemeProvider fullWidthView={standalonePage}>
        <AppContext.Provider value={appContext}>
          <EnvironmentContextProvider
            showPaymentContainer={false}
            containerConfig={undefined}
            postMessage={undefined}
          >
            <NotificationContext.Provider
              value={notificationContext}
            >
              <DrawerContext.Provider value={drawerContextValue}>
                {standalonePage ? (
                  checkoutSessionId ? (
                    <ContainerAppEnvChekoutSession
                      appEnv={appEnv}
                      checkoutSessionId={checkoutSessionId}
                    >
                      <LanguageSelector>
                        <UnifiedRouter />
                      </LanguageSelector>
                    </ContainerAppEnvChekoutSession>
                  ) : (
                    <UnifiedRouter />
                  )
                ) : (
                  <AppContainer onCancel={onCancel}>
                    <LanguageSelector>
                      <UnifiedRouter />
                    </LanguageSelector>
                  </AppContainer>
                )}
              </DrawerContext.Provider>
            </NotificationContext.Provider>
          </EnvironmentContextProvider>
        </AppContext.Provider>
      </CCGThemeProvider>
    </ServiceContextProvider>
  );
};

export default App;
